module.exports = __webpack_public_path__ + "img/missionaries6_2019_7-7-2021.245a18b9.jpg";